import React, { Component } from 'react';
import { connect } from 'react-redux';

import Layout from '../../components/layout';
import Loading from '../../components/spinner';
// import { Title } from '../../components/common'
import { withTranslation } from '../../lib/translate';
import { getFaq } from '../../store/actions';
import NoData from '../../components/noData';

import './index.css';

class Faq extends Component {
  componentDidMount() {
    if (!this.props.faq) {
      setTimeout(() => {
        this.props.dispatch(getFaq());
      }, 1000);
    }
  }

  render() {
    const { __, faq } = this.props;
    return (
      <Loading transparent>
        <Layout
          headerWithTitle
          hideSecondToolbar
          showHamburgerIcon
          headerTitle={__('Faq & Support')}
        >
          <div className="absolute-content scrollable-y">
            {/* <Title>{ __('Faq & Support') }</Title> */}
            {faq ? <div dangerouslySetInnerHTML={{ __html: faq }} /> : <NoData />}
          </div>
        </Layout>
      </Loading>
    );
  }
}

const stateToProps = (state) => {
  return {
    faq: state.common.faq || null,
  };
};

export default connect(stateToProps)(withTranslation(Faq));
